import { CoverflowCarouselSection } from '@/types/coverflowCarousel';

// Helper function to transform CoverflowCarouselSection data to carousel format
export const transformCarouselData = (
  data: CoverflowCarouselSection,
): {
  carouselData: { heading: any; description: any };
  carouselItems: Array<{
    id: string;
    title: string;
    slug?: string;
    functionality: 'internal_link';
    button: {
      content: string;
    };
    image: {
      url: string;
      title: string;
      description: string;
      slug?: string;
    };
  }>;
} => {
  const carouselData = {
    heading: data.heading || 'Our Services',
    description:
      data.description || 'Discover our comprehensive healthcare services',
  };

  const images = data.imagesCollection?.items ?? data.images ?? [];

  const carouselItems = images.map((item, index) => ({
    id: `${data.sys.id}-${index}`,
    title: item.title || 'Healthcare Service',
    slug: item.link || item.slug,
    functionality: 'internal_link' as const,
    button: {
      content: 'View Service',
    },
    image: {
      url: item.url,
      title: item.title || 'Healthcare Service',
      description: item.description || item.title || '',
      slug: item.link || item.slug,
    },
  }));

  return { carouselData, carouselItems };
};
